import { useMainStore } from '~/stores/mainStore';

export default defineNuxtRouteMiddleware(() => {
  const mainStore = useMainStore();

  if (!mainStore.siteSettings.canViewUtilityConnect) {
    return navigateTo('/');
  }
});
